<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-toolbar class="md-success">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <test-menu @on-selected="onSelectedTestProfile" ref="testMenu"></test-menu>
            </div>
          </div>
        </md-toolbar>
        <br />
      </div>
    </div>

        <div class="modal-footer">
      <md-button
        v-show="testProfile.testCases.length"
        class="md-just-icon md-info md-round"
        :title="$lang.keys.add_test_case"
        @click="showTestCaseDialog()"
      >
        <md-icon>{{showAddingTestCaseDialog ? 'remove' : 'add'}}</md-icon>
      </md-button>
    </div>

    <slide-y-up-transition :duration="200">
      <md-empty-state
        v-if="showEmptyState"
        md-icon="post_add"
        :md-label="$lang.titles.create_first_test_case"
      >
        <md-button
          class="md-primary md-raised"
          @click="showTestCaseDialog()"
        >{{$lang.keys.add_test_case}}</md-button>
      </md-empty-state>
    </slide-y-up-transition>

    

    <zoom-center-transition :duration="300" :delay="!showEmptyState ? 200 : 0" mode="out-in">
      <div v-if="!showEmptyState" class="md-layout">
        <div class="md-layout-item md-size-60 md-medium-size-80 md-xsmall-size-100 mx-auto">
          <collapse-transition>
            <simple-wizard
              v-if="showAddingTestCaseDialog"
              :prevButtonText="$lang.keys.back"
              :nextButtonText="$lang.keys.next"
              :finishButtonText="$lang.keys.save"
            >
              <template slot="header">
                <h4 class="title">{{testCaseDialog.title}}</h4>
                <!-- <h5 class="category"></h5>-->
              </template>

              <wizard-tab :before-change="() => validateStep('step1')">
                <template slot="label">{{$lang.titles.generator}}</template>
                <first-step
                  ref="step1"
                  @on-validated="onStepValidated"
                  :generatorData="testCaseDialog.generator"
                ></first-step>
              </wizard-tab>

              <wizard-tab :before-change="() => validateStep('step2')">
                <template slot="label">{{$lang.titles.test_conditions}}</template>
                <second-step
                  ref="step2"
                  @on-validated="onStepValidated"
                  :settings="testCaseDialog.testConditions"
                ></second-step>
              </wizard-tab>
            </simple-wizard>
          </collapse-transition>

          <draggable
            v-model="testProfile.testCases"
            draggable=".md-card"
            v-bind="dragOptions"
            @start="drag = true"
            @end="onDragEnd()"
          >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <md-card v-for="(item, idx) in testProfile.testCases" :key="idx">
                <md-card-header>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-20">
                      <span class="badge badge-info">{{idx+1}}</span>
                    </div>

                    <div class="md-layout-item md-size-10 ml-auto">
                      <div class="position-right">
                        <md-button
                          class="md-just-icon md-simple md-primary"
                          @click="editTestCase(idx)"
                        >
                          <md-icon>edit</md-icon>
                        </md-button>

                        <md-button
                          class="md-just-icon md-simple md-danger"
                          @click="deleteTestCase(idx)"
                        >
                          <md-icon>close</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </md-card-header>
                <md-card-content style="padding: 0px 20px;">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-medium-size-50 md-xsmall-size-100">
                      <h6 class="title">{{$lang.titles.generator}}</h6>
                      <div
                        class="md-field md-chips md-warning md-theme-default md-theme-default md-has-value"
                      >
                        <md-chip v-for="(chip, idx) in item.tags_generator" :key="idx">{{ chip }}</md-chip>
                      </div>




 <!-- <div class="md-layout">
      <label class="md-layout-item md-size-5 md-form-label">L1</label>
      <div class="md-layout-item md-size-95 mx-auto">
        <div class="md-field md-chips md-warning md-theme-default md-theme-default md-has-value">
                        <md-chip v-for="(chip, idx) in item.tags.generator.L1" :key="idx">{{ chip }}</md-chip>
                      </div>
      </div>
    </div>

 <div class="md-layout">
      <label class="md-layout-item md-size-5 md-form-label">L2</label>

      <div class="md-layout-item md-size-95 mx-auto">

        <div class="md-field md-chips md-warning md-theme-default md-theme-default md-has-value">
                        <md-chip v-for="(chip, idx) in item.tags.generator.L2" :key="idx">{{ chip }}</md-chip>
                      </div>
      </div>
    </div>

        <div class="md-layout">
      <label class="md-layout-item md-size-5 md-form-label">L2</label>

      <div class="md-layout-item md-size-95">

        <div class="md-field md-chips md-warning md-theme-default md-theme-default md-has-value">
                        <md-chip v-for="(chip, idx) in item.tags.generator.L3" :key="idx">{{ chip }}</md-chip>
                      </div>
      </div>
    </div>  -->

















                    </div>

                    <div
                      class="md-layout-item md-size-50 md-medium-size-50 md-xsmall-size-100 ml-auto"
                    >
                      <h6 class="title">{{$lang.titles.test_conditions}}</h6>
                      <md-chips v-model="item.tags_testValues" class="md-info" md-static></md-chips>
                    </div>
                  </div>

                  <div class="md-layout"></div>
                </md-card-content>
              </md-card>
            </transition-group>
          </draggable>
        </div>
      </div>
    </zoom-center-transition>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import TestMenu from "../components/TestProfilesMenu.vue";
import axios from "axios";
import snackBar from "@/components/SnackBar";
import config from "@/config/config";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import {
  CollapseTransition,
  SlideYUpTransition,
  ZoomCenterTransition
} from "vue2-transitions";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  components: {
    TestMenu,
    "snack-bar": snackBar,
    FirstStep,
    SecondStep,
    SimpleWizard,
    WizardTab,
    draggable,
    SlideYUpTransition,
    CollapseTransition,
    ZoomCenterTransition
  },

  data() {
    return {
      wizardModel: {},
      dragOptions: {
        animation: 300,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      },
      drag: false,
      showAddingTestCaseDialog: false,
      showEmptyState: true,
      selectAllTestConditionsValue: false,
      testCaseDialog: {
        title: "",
        generator: {},
        testContitions: {}
      },
      testProfile: {
        ID: 0,
        testCases: []
      }
    };
  },

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  created(){
    this.$store.commit("setLoading", true);
  },

  methods: {
    validateStep(ref) {
      const validation = this.$refs[ref].validate();
      return validation;
    },

    onStepValidated(validated, model, finish) {
      this.wizardModel = { ...this.wizardModel, ...model };
      if (finish) {
        this.saveNewTestCase();
      }
    },

    onSelectedTestProfile(testProfile) {
      this.testProfile = testProfile;

      if (this.testProfile.testCases.length > 0) {
        this.showEmptyState = false;
      } else {
        this.showEmptyState = true;
      }

      this.$store.commit("setLoading",false);
    },

    saveNewTestCase() {
      let testValues = [];
      let generatorValues = [];

      // let tags = {
      //   generator: {
      //     L1: [],
      //     L2: [],
      //     L3: []
      //   },
      //   testConditions: {
      //     L1: [],
      //     L2: [],
      //     L3: []
      //   }
      // }

      const sortWeight = [{
        value: "V",
        weight: 1
      },
      {
        value: "I",
        weight: 2
      },
      {
        value: "P",
        weight: 3
      },
      {
        value: "Q",
        weight: 4
      },
      {
        value: "S",
        weight: 5
      }];

        this.wizardModel.conditions.sort(function(a, b){
        const a_index = sortWeight.findIndex(val => val.value === a.charAt(0));
        const b_index = sortWeight.findIndex(val => val.value === b.charAt(0));

        if (a_index == b_index){
          return a.charAt(1) > b.charAt(1);
        }

        return sortWeight[a_index].weight - sortWeight[b_index].weight;
      });


      this.wizardModel.conditions.forEach(el => {
        testValues.push(el);
      });

      // this.wizardModel.conditions.forEach(el => {
      //   if (el.charAt(0) === "V") {
      //     const tag =
      //       this.$lang.menu.voltage + " " + this.wizardModel.accuracy.U + "%";
      //     if (testValues.findIndex(val => val == tag) == -1) {
      //       testValues.push(tag);
      //     }
      //   }
      //   if (el.charAt(0) === "I") {
      //     const tag =
      //       this.$lang.menu.current + " " + this.wizardModel.accuracy.I + "%";
      //     if (testValues.findIndex(val => val == tag) == -1) {
      //       testValues.push(tag);
      //     }
      //   }
      //   if (el.charAt(0) === "P") {
      //     const tag =
      //       this.$lang.menu.active_power +
      //       " " +
      //       this.wizardModel.accuracy.P +
      //       "%";
      //     if (testValues.findIndex(val => val == tag) == -1) {
      //       testValues.push(tag);
      //     }
      //   }
      //   if (el.charAt(0) === "Q") {
      //     const tag =
      //       this.$lang.menu.reactive_power +
      //       " " +
      //       this.wizardModel.accuracy.Q +
      //       "%";
      //     if (testValues.findIndex(val => val == tag) == -1) {
      //       testValues.push(tag);
      //     }
      //   }
      //   if (el.charAt(0) === "S") {
      //     const tag =
      //       this.$lang.menu.apparent_power +
      //       " " +
      //       this.wizardModel.accuracy.S +
      //       "%";
      //     if (testValues.findIndex(val => val == tag) == -1) {
      //       testValues.push(tag);
      //     }
      //   }
      // });



      // testValues.sort(function(a, b){
      //   const a_index = sortWeight.findIndex(val => val.value === a.charAt(0));
      //   const b_index = sortWeight.findIndex(val => val.value === b.charAt(0));

      //   if (a_index == b_index){
      //     return a.charAt(1) > b.charAt(1);
      //   }

      //   return sortWeight[a_index].weight - sortWeight[b_index].weight;
      // });


      Object.keys(this.wizardModel.generator).forEach(key => {
        Object.keys(this.wizardModel.generator[key]).forEach(key2 => {
          const value = this.wizardModel.generator[key][key2];
          switch (key) {
            case "U":
              generatorValues.push(value + "V");
              //tags.generator[key2].push(value + "V");
              break;
            case "I":
              generatorValues.push(value + "A");
              //tags.generator[key2].push(value + "A");
              break;
            case "ANGLE_U":
            case "ANGLE_I":
              generatorValues.push(value + "°");
              //tags.generator[key2].push(value + "°");
              break;
          }
        });
      });

      const newTestCase = {
        generatorData: this.wizardModel.generator,
        testConditions: this.wizardModel.conditions,
        accuracy: this.wizardModel.accuracy,
        tags_testValues: testValues,
        tags_generator: generatorValues,
        //tags: tags
      };

      if (this.testCaseDialog.edit === true) {
        this.testProfile.testCases[
          this.testCaseDialog.arrayIndex
        ] = newTestCase;
      } else {
        this.testProfile.testCases.push(newTestCase);
      }

      this.$refs.testMenu.updateTestProfile(this.testProfile);
      this.showAddingTestCaseDialog = false;
    },

    showTestCaseDialog() {
      if (!this.showAddingTestCaseDialog) {
        //default settings
        this.testCaseDialog = {
          title: this.$lang.titles.add_new_test_case,
          generator: {
            U: {
              L1: "240",
              L2: "240",
              L3: "240"
            },
            I: {
              L1: "1",
              L2: "1",
              L3: "1"
            },
            ANGLE_U: {
              L1: "0",
              L2: "60",
              L3: "120"
            },
            ANGLE_I: {
              L1: "60",
              L2: "60",
              L3: "60"
            },
            freq: "50"
          },
          testContitions: {
            conditions: [],
            accuracy: {
              U: "1.00",
              I: "1.00",
              P: "1.00",
              Q: "1.00",
              S: "1.00"
            }
          }
        };

        this.showEmptyState = false;
        this.selectAllTestConditionsValue = false;
        this.showAddingTestCaseDialog = true;
      } else {
        this.showAddingTestCaseDialog = false;
      }
    },

    deleteTestCase(index) {
      Swal.queue([{
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            this.testProfile.testCases.splice(index, 1);
            this.$refs.testMenu.updateTestProfile(this.testProfile);

            Swal.insertQueueStep({
              title: this.$lang.messages.success,
              text: this.$lang.messages.success_removed_test_case,
              type: "success",
              confirmButtonClass: "md-button md-success",
              confirmButtonText: this.$lang.keys.close,
              buttonsStyling: false,
              timer: config.timers.swalautoclose,
              onClose: () => {
                if (this.testProfile.testCases.length == 0) {
                  this.showEmptyState = true;
                }
              }
            });
          }
        }]);
    },

    editTestCase(index) {
      this.testCaseDialog = {
        title: this.$lang.titles.edit_test_case + " " + Number(index + 1),
        generator: this.testProfile.testCases[index].generatorData,
        testConditions: {
          conditions: this.testProfile.testCases[index].testConditions,
          accuracy: this.testProfile.testCases[index].accuracy
        },
        edit: true,
        arrayIndex: index
      };

      this.showAddingTestCaseDialog = true;
      window.scrollTo(0,0);
    },

    onDragEnd() {
      this.drag = false;
      this.$refs.testMenu.updateTestProfile(this.testProfile);
    }
  }
};
</script>

<style scoped>
.md-chips.md-field {
  padding-top: 0px;
}

.position-right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 0px;
  padding-top: 0;
}
</style>